module.exports = __webpack_public_path__ + "static/logo.155afb07.png";


//////////////////
// WEBPACK FOOTER
// /Users/d064310/Development/playland/colorribbon/src/images/logo.png
// module id = 701
// module chunks = 0